import {FormError, FormValues} from '@wix/form-viewer'
import {FormViewer, FormViewerContext, FormViewerHandle} from '@wix/form-viewer/widget'
import {getFormId} from '@wix/wix-events-commons-statics'
import {useBi, useTranslation} from '@wix/yoshi-flow-editor'
import React, {useRef, useState} from 'react'
import {useAppActions, useAppProps, useAppSelector} from '../../hooks/runtime'
import {getEvent} from '../../selectors/event'
import {FormViewerContextProps} from './interfaces'

export const WixForm = () => {
  const appProps = useAppProps() as FormViewerContextProps
  const bi = useBi()
  const {i18n} = useTranslation()
  const event = useAppSelector(getEvent)
  const {submitRsvpStep} = useAppActions()

  const formViewer = useRef<FormViewerHandle>(null)
  const [formValues, setFormValues] = useState<FormValues>({})
  const [formErrors, setFormErrors] = useState<FormError[]>([])

  const formId = getFormId(event)

  const submitForm = async (_, submittedFormId: string, submissions: Record<string, any>) =>
    submitRsvpStep({submissions, formId: submittedFormId})

  return (
    <FormViewerContext
      {...appProps}
      wfActions={{
        ...appProps.wfActions,
        submitForm,
      }}
    >
      <FormViewer
        i18n={i18n}
        bi={bi}
        ref={formViewer}
        values={formValues}
        errors={formErrors}
        onValidate={setFormErrors}
        onChange={setFormValues}
        formId={formId}
      />
    </FormViewerContext>
  )
}
